require('./tppKeyError.scss');
const PropTypes = require('prop-types');
const React = require('react');
// @ commons
const { OKLink } = require('commonsComponents/OKLink');
// @ constants

//@helpers
const { FormattedText } = require('core/i18n').i18n;

class TppKeyError extends React.Component {
    render() {
        const { title, onRetry } = this.props;
        return (
            <div className="tpp-key-error">
                <div className="tpp-key-error__icon-error"></div>
                <div className="tpp-key-error__title">
                    {title}
                </div>
                <span className="tpp-key-error__separator"></span>
                <div className="tpp-key-error__title-description">
                    <FormattedText value="keysTppView-descriptionTitleTppKeyError"/>
                </div>
                <div className="tpp-key-error__description">
                    <FormattedText value="keysTppView-descriptionTppKeyError"/>
                </div>
                <div className="tpp-key-error__divider"></div>
                <div className="tpp-key-error__link">
                    <OKLink onClick={onRetry} modifier="complementary" inverse={false}>
                        <FormattedText value="keysTppView-retryTppKey"/>
                    </OKLink>
                </div>
            </div>
        );
    }
}

TppKeyError.propTypes = {
    onRetry: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
};

module.exports = TppKeyError;